import ContractIcon from "../assets/images/icon/contract/contract-doc-icon.svg";
import SecretIcon from "../assets/images/icon/contract/secret-doc-icon.svg";

export const CONTRACT_TYPE = [
  {
    label: '근로계약서',
    description: '정규직 연봉',
    type: 'YEAR_SALARY_REGULAR_WORKER',
    icon: ContractIcon
  },
  {
    label: '근로계약서',
    description: '정규직 월급',
    type: 'MONTH_SALARY_REGULAR_WORKER',
    icon: ContractIcon
  },
  {
    label: '근로계약서',
    description: '계약직 연봉',
    type: 'YEAR_SALARY_CONTRACT_WORKER',
    icon: ContractIcon
  },
  {
    label: '근로계약서',
    description: '계약직 월급',
    type: 'MONTH_SALARY_CONTRACT_WORKER',
    icon: ContractIcon
  },
  // {
  //   label: '근로계약서',
  //   description: '단시간 근로',
  //   type: 'PART_TIME_WORKER',
  //   icon: ContractIcon
  // },
  {
    label: '개인정보 이용 동의서',
    type: 'PRIVACY_POLICY',
    icon: ContractIcon
  },
  // {
  //   label: '여성근로자 야간 근로 동의서',
  //   type: 'NIGHT_WORKER',
  //   icon: ContractIcon
  // },
  {
    label: '비밀 보호 서약서',
    type: 'CONFIDENTIALITY_PLEDGE',
    icon: SecretIcon
  },
];

export const SIGN_TEXT = "(인)";
